import script from "./email-template.vue?vue&type=script&setup=true&lang=js"
export * from "./email-template.vue?vue&type=script&setup=true&lang=js"

import "./email-template.vue?vue&type=style&index=0&id=6ce24475&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ce24475"]])

export default __exports__